<template>
    <div class="container">
        <div class="header">
            <div class="title">物流详情</div>
            <div class="close" @click="$router.back()">
                <van-icon name="cross" />
            </div>
        </div>
        <div class="swiper" v-if="logistics.nav.length!=1&&!logistics.none">
            <span v-for="(item,index) in logistics.nav" :key="item.id" @click="swiperChange(index)" :class="index==swiperCurrentIndex?'active':''">包裹{{index+1}}</span>
        </div>
        <div class="logistics" v-watermark>
            <van-empty :description="logistics.none" v-if="logistics.none" />
            <div class="logistics-box" v-else>
                <div class="no" v-if="logistics.logisticsNo"> <span>{{logistics.shipperName }}:</span> {{ logistics.logisticsNo }} <span class="copy" @click="copy(logistics.logisticsNo)">复制</span></div>
                <div class="logistics-list">
                    <div class="item" v-for="(item, index) in logistics.list" :key="index">
                        <div class="dot"></div>
                        <div class="item-box">
                            <!-- <div class="name">{{ item.status }}</div> -->
                            <div class="time">{{ item.time }}</div>
                            <div class="content">{{ item.context }}</div>
                        </div>
                    </div>
                    <div class="item" v-if="!logistics.list.length">
                        <div class="dot"></div>
                        <div class="item-box">
                            <div class="name">待揽收</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getLogistic,getLogisticsDetails } from '@/api/index'
export default {
    data() {
        return {
            logistics: {
                list: [],
                logisticsNo: '',
                none: '',
                nav:[],
                shipperName:''
            },
            parameter:{},
            swiperCurrentIndex:0
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.onDataGet()
        },
        onDataGet() {
            getLogistic({ askNo: this.$route.query.askNo,type:0 }).then(({ data }) => {
                if (data) {
                    this.logistics.logisticsNo = data[0].waybillNum
                    this.logistics.nav = data
                    this.swiperChange(0)
                } else {
                    this.logistics.none = '暂无物流信息';
                }
            }).catch(() => {
                this.logistics.none = '暂无物流信息';
            })
        },
        swiperChange(e) {
			this.swiperCurrentIndex = e; //修改滚动索引
			this.requestParam(this.swiperCurrentIndex); //请求物流详情的参数
		},
        copy(value) {
            const input = document.createElement("input");
            input.value = value;
            document.body.appendChild(input);
            input.select();
            document.execCommand("Copy");
            document.body.removeChild(input);
            this.$toast("复制成功");
        },
		requestParam(e) {
			//获取物流详情的请求参数
			for (var i = 0; i < this.logistics.nav.length; i++) {
				this.parameter.id = this.logistics.nav[e].id;
				this.parameter.singleNumber = this.logistics.nav[e].waybillNum;
				this.parameter.express = this.logistics.nav[e].express;
				this.parameter.senderMobile = this.logistics.nav[e].senderMobile;
			}

			this.loadExpress(); //获取物流详情跟踪信息
		},
        //获取包裹物流信息
        async loadExpress (){
            let {data} = await getLogisticsDetails(this.parameter)
            console.log(data,"datadatadatadata")
            // if(data.data){
            //     data.data.forEach(item=>{
            //         item.time = this.getTimeformate(item.time)
            //     })
            // }
            this.logistics.shipperName = data.shipperName
            this.logistics.list = data.data || [];
        },
        add0(m) {
			return m < 10 ? '0' + m : m;
		},
		getTimeformate(time) {
			let datetime = new Date(time);
			let year = datetime.getFullYear();
			let month = datetime.getMonth() + 1;
			let date = datetime.getDate();
			let h = datetime.getHours();
			let mm = datetime.getMinutes();
			let s = datetime.getSeconds();
			return year + '-' + this.add0(month) + '-' + this.add0(date) + ' ' + this.add0(h) + ':' + this.add0(mm) + ':' + this.add0(s);
		}
    }
}
</script>
<style lang="scss" scoped>
.container {
    background: #fff;
    min-height: 100vh;

    .header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;

        .title {
            font-weight: bold;
            font-size: 18px;
        }
    }

    .logistics {
        height: calc(100vh - 100px);
        overflow-y: auto;

        .no {
            margin-bottom: 20px;
        }

        &-box {
            padding: 10px 20px;

            .item {
                position: relative;
                display: flex;

                .dot {
                    flex: none;
                    width: 15px;
                    height: 15px;
                    background: #d7d7d7;
                    border-radius: 50px;
                    margin-right: 20px;

                    &::before {
                        content: "";
                        position: absolute;
                        left: 7px;
                        top: 16px;
                        bottom: 0;
                        z-index: 0;
                        border-left: 3px dotted #d7d7d7;
                    }
                }

                &:last-child {
                    .dot {
                        &::before {
                            display: none;
                        }
                    }
                }

                &-box {
                    padding-bottom: 20px;

                    .name {
                        font-weight: bold;
                        font-size: 14px;
                        margin-top: -3px;
                    }

                    .time {
                        margin-top: 10px;
                        color: #999;
                        font-size: 12px;
                    }

                    .content {
                        margin-top: 10px;
                        word-break: break-all;
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
.swiper{
    // position: fixed;
    margin-bottom: 20px;
    padding-left: 20px;
    box-sizing: border-box;
    span{
        // color: #7c807f;
		// width: 60px;
		font-size: 18px;
        margin-right:16px;
        position: relative;
        padding-bottom: 6px;
        &::after{
            content: '';
            width: 50%;
			height: 4px;
            left: 0;right: 0;bottom: 0;top: 0;
            margin:auto auto 0;
            position: absolute;
			background: #fff;
			border-radius: 6px;
        }
    }
    .active::after{
        background: #33c2b4;
    }
}
.copy {
    margin-left: 8px;
    padding: 4px;
    border-radius: 4px;
    color: #fff;
    display: inline-block;
    background: rgb(25, 137, 250);
    font-size: 14px;
    font-weight: normal;
}
</style>